<template>
  <div ref="containerEditorRef" class="container-custom-editor">
    <div ref="quillEditorTarget"></div>
    <div ref="wrapperToolbarRef" class="wrapper-toolbar">
      <div v-if="emailAttachments && emailAttachments.length > 0" class="container-email-attachments">
        <span
          v-for="(attachment, i) in emailAttachments" :key="i"
          class="email-attachments-item"
        >
          <div class="name" :title="attachment.name">
            {{ attachment.name }} ({{ calculateSizeInMB(attachment.size) }})
          </div>
          <i class='qcw-icon' style="cursor: pointer" @click="deleteAttachment(i)">
            <icon name="ic-close" fill="#EF7D7C" style="width: 15px; height: 15px;" />
          </i>
        </span>
      </div>
      <div id="customToolbarplace">
        <button class="ql-bold"></button>
        <button class="ql-italic"></button>
        <button class="ql-underline"></button>
        <button class="ql-strike"></button>
        <button class="ql-align" value="right"></button>
        <button class="ql-align" value="center"></button>
        <button class="ql-align" value="justify"></button>
        <button class="ql-list" value="ordered"></button>
        <button class="ql-list" value="bullet"></button>
        <select class="ql-size">
          <option value="small"></option>
          <option selected></option>
          <option value="large"></option>
          <option value="huge"></option>
        </select>
        <span class="counter-limit">
          <small>{{textLength}}/{{maxCharacter}}</small>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.core.css';

import Quill from 'quill';
import { QuillDeltaToHtmlConverter } from 'quill-delta-to-html';
import TurndownService from 'turndown';
import { calculateSizeInMB } from '../lib/utils';
import Icon from './Icon';

export default {
  name: 'WywygEditor',
  components: {
    Icon,
  },
  props: ['emailAttachments'],
  computed: {
    textLength() {
      if (this.QuillObject) {
        return this.QuillObject.getText().length - 1;
      }
      return 0;
    },
  },
  data() {
    return {
      QuillObject: null,
      maxCharacter: 3000,
    };
  },
  watch: {
    emailAttachments() {
      if (this.$refs.containerEditorRef) {
        setTimeout(() => {
          this.$refs.containerEditorRef.style.marginBottom = `${this.$refs.wrapperToolbarRef.offsetHeight}px`;
        }, 0);
      }
    },
  },
  mounted() {
    this.QuillObject = new Quill(this.$refs.quillEditorTarget, {
      modules: {
        toolbar: '#customToolbarplace',
      },
      theme: 'snow',
      formats: ['bold', 'underline', 'italic', 'link', 'align', 'list', 'size', 'strike'],
      placeholder: 'Type something in here!',
    });
    this.QuillObject.on('text-change', this.emitOnchange);
  },
  beforeDestroy() {
    this.QuillObject.off('text-change', this.emitOnchange);
  },
  methods: {
    emitOnchange() {
      if (this.textLength > this.maxCharacter) {
        this.QuillObject.deleteText(this.maxCharacter, this.QuillObject.getLength());
      }
      const contents = this.QuillObject.getContents();
      const converter = new QuillDeltaToHtmlConverter(
        contents.ops,
        {
          inlineStyles: true,
          encodeHtml: false,
        },
      );
      const html = converter.convert();
      this.$emit('onchange', html);
    },
    deleteText() {
      this.QuillObject.deleteText(0, this.QuillObject.getLength());
    },
    setText(value) {
      this.QuillObject.setText(value);
    },
    getContents() {
      const contents = this.QuillObject.getContents();
      const converter = new QuillDeltaToHtmlConverter(
        contents.ops,
        {
          inlineStyles: true,
          encodeHtml: false,
        },
      );
      const html = converter.convert();
      const turndownService = new TurndownService();
      return turndownService.turndown(html);
    },
    calculateSizeInMB,
    deleteAttachment(index) {
      this.$emit('ondeleteAttachment', index);
    },
  },
};
</script>
<style>
.container-custom-editor {
  width: 100%;
  position: relative;
  margin-bottom: 37px;
  max-height: 100px;
}
.ql-container.ql-snow {
  border: none !important;
  font-family: inherit;
  font-size: 14px;
}
.ql-editor.ql-blank::before {
  font-style: normal;
}
.wrapper-toolbar {
  position: absolute;
  width: 100%;
}
#customToolbarplace {
  position: relative;
  /* width: 100%; */
  border: none;
  padding: 15px 0px 0px 10px;
}
.ql-snow .ql-picker.ql-expanded .ql-picker-options {
  top: unset !important;
  bottom: 100%;
}
#customToolbarplace > .counter-limit {
  position: absolute;
  right: 15px;
  color: #B6B6B6;
}
.container-email-attachments {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0px 15px;
  gap: 20px;
}
.container-email-attachments > .email-attachments-item {
  display: flex;
  align-items: center;
  background: #E7E7E7;
  padding: 2px 5px 2px 8px;
  border-radius: 4px;
}
.email-attachments-item .name {
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/WywygEditor.vue